module.exports = __webpack_public_path__ + "img/hall-blue.caaa7e86.png";